import React, { Component } from "react";
import _ from "lodash";
import { connect } from "react-redux";
// import actionFilter from "../../store/advancedfilter/action";
import actionFilter from "../../../store/advancedfilter/action";

class Type extends Component {
  onChange(item) {
    var memberTypeIndex = _.findIndex(
      this.props.filterState.filterData.memberType,
      (o) => {
        return o.id === item.id;
      }
    );
    item.checked = !this.props.filterState.filterData.memberType[
      memberTypeIndex
    ].checked;
    this.props.filterState.filterData.memberType[memberTypeIndex] = item;
    this.props.setFilterData({
      ...this.props.filterState.filterData,
    });
  }
  chechboxes(item) {
    return (
      <li className="chechbox-list_item" key={"fliitem-" + item.id}>
        <span
          className="card-text custom-checkbox ml-3 mr-4"
          key={"ritem-" + item.id}
        >
          <input
            type="checkbox"
            htmlFor={"mtitem-" + item.id}
            value={item.id}
            checked={item.checked}
            className="custom-control-input"
            id={"mtitem-" + item.id}
            name={"mtitem-" + item.id}
            onChange={() => this.onChange(item)}
          />

          <label
            className="custom-control-label"
            style={{ color: this.props.isMobile ? "white" : null }}
            htmlFor={"mtitem-" + item.id}
          >
            {item.description}
            <small className="totalCount">{`(${item.total})`}</small>
          </label>
        </span>
      </li>
    );
  }

  render() {
    return (
      <>
        {this.props.isMobile !== true ? (
          <>
            <h4>Member Type</h4>
            <hr />
          </>
        ) : (
          ""
        )}
        <div className="filter-fields-scroll">
          <ul className="chechbox-list">
            {this.props.filterState.filterData.memberType &&
              !_.isEmpty(this.props.filterState.filterData) &&
              this.props.filterState.filterData.memberType.map((item) =>
                this.chechboxes(item)
              )}
          </ul>
        </div>
        <div className="height-scroll"></div>
      </>
    );
  }
}

export default connect((state) => ({ filterState: state.advancedFilter }), {
  ...actionFilter,
})(Type);
